import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './zTimeHoursMinutes.translations.json';

const { addTranslations, t } = i18nNsFactory('z-time-hours-minutes');
addTranslations(translations);

const TIME_HOURS_MINUTES_REGEX = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;

export const zTimeHoursMinutes = (messageFn?: () => string | undefined) =>
  z.custom<`${number}${number}:${number}${number}`>(
    (value) =>
      typeof value === 'string' && TIME_HOURS_MINUTES_REGEX.test(value),
    () => ({
      message: messageFn?.() || t('invalid'),
    }),
  );
